'use client'

import type { ProductCardWishlistWrapperProps } from '@maestro/commerce-blocks/components/product-card/product-card.types'

import { Button } from '@pearlconvert/ui/components/button'

export default function ProductCardWishlistWrapper(
  props: ProductCardWishlistWrapperProps
) {
  const { handleWishlistToggle, wishlistButtonProps } = props
  return (
    <Button
      className="product-card__button--addtowishlist"
      {...wishlistButtonProps}
      type="empty"
      onClick={handleWishlistToggle}
    />
  )
}
